import { EventBusKey } from "@vueuse/core";

export const snackbarMessageKey: EventBusKey<SnackbarMessage> = Symbol()

export interface SnackbarMessage {
    message: string;
    type: string;
    id: string;
}